import { Box, TextField } from "@mui/material"
import { EvaluationCardScore } from "../EvaluationCardScore"

export const EvaluationQuestionsFooter = ({
	observation,
	setObservation,
	averageCompetency,
	noComment,
}) => {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2, width: "100%" }}>
			<EvaluationCardScore label="Promedio De Preguntas" value={`${averageCompetency}`} />
			{!noComment && (
				<TextField
					label="Observaciones"
					fullWidth
					multiline
					rows={4}
					value={observation}
					onChange={(e) => {
						setObservation(e.target.value)
					}}
				/>
			)}
		</Box>
	)
}
